import { BaseAction, actionTypes } from 'redux/actions';
import { PolicyAddEnListReq, VehicleBrand } from 'bff/models/product';
import { GameChkqualifyResp } from 'bff/models/game/gameChkqualify';

export interface ModalState {
  gameQualifyModalState: {
    visible: boolean;
    gamePoi?: string;
    applyNo?: string;
    /** 抽獎資格查詢結果 */
    checkResult?: GameChkqualifyResp;
  };
  captchaErrorModalVisible: boolean;
  captchaSendModalVisible: boolean;
  captchaReturnModalVisible: boolean;
  infoModalState: {
    visible: boolean;
    title?: string;
    content?: string;
  }
  guardianshipStatementModalVisible: boolean;
  fillPassportModalState: {
    visible: boolean;
    insureds?: any[];
    serialNo?: string;
    setAddEnListReq?: (data: PolicyAddEnListReq | null) => void
  };
  loadingModalState: {
    visible: boolean;
    dealing?: boolean;
    policyperiod?: boolean;
    petLoading?: boolean;
  };
  ruleValidErrorModalState: {
    visible: boolean;
    errorMsgs: string[];
  };
  fillExampleModalVisible: boolean;
  selectVehicleBrandsModalState: {
    visible: boolean;
    vehicleBrands: VehicleBrand[];
    selectItem?: VehicleBrand
  };
  selectVehicleModelsModalState: {
    visible: boolean;
  };
  selectInsuranceTypeModalState: {
    visible: boolean;
    memberId?: string;
    nationalityType?: string;
  };
  memberInfoErrorModalState: {
    visible: boolean;
    title?: string;
    content?: string;
    fieldNames?: string[];
  },
  loginModalState: {
    visible: boolean;
  },
  vetHospitalModalVisible: boolean;
  insureHelperModalVisible: boolean;
  abroadModalVisible: boolean;
  explainModalVisible: boolean;
  productExplainModalVisible: boolean;
  confirmModalVisible: boolean;
}

const initialState: ModalState = {
  gameQualifyModalState: {
    visible: false
  },
  captchaErrorModalVisible: false,
  captchaSendModalVisible: false,
  captchaReturnModalVisible: false,
  infoModalState: {
    visible: false
  },
  guardianshipStatementModalVisible: false,
  fillPassportModalState: {
    visible: false,
    insureds: new Array(0),
    serialNo: ''
  },
  loadingModalState: {
    visible: false,
    dealing: false,
    policyperiod: false,
    petLoading: false
  },
  ruleValidErrorModalState: {
    visible: false,
    errorMsgs: new Array(0)
  },
  fillExampleModalVisible: false,
  selectVehicleBrandsModalState: {
    visible: false,
    vehicleBrands: new Array(0)
  },
  selectVehicleModelsModalState: {
    visible: false
  },
  selectInsuranceTypeModalState: {
    visible: false,
    memberId: '',
    nationalityType: ''
  },
  memberInfoErrorModalState: {
    visible: false
  },
  loginModalState: {
    visible: false
  },
  vetHospitalModalVisible: false,
  insureHelperModalVisible: false,
  abroadModalVisible: false,
  explainModalVisible: false,
  productExplainModalVisible: false,
  confirmModalVisible: false
};

export const modalReducer = (state: ModalState = initialState, action: BaseAction) => {
  switch (action.type) {
    case actionTypes.MODAL.SET_GAME_QUALIFY_MODAL_VISIBLE:
      return {
        ...state,
        gameQualifyModalState: {
          ...action.payload
        }
      };
    case actionTypes.MODAL.SET_CAPTCHA_ERROR_MODAL_VISIBLE:
      return {
        ...state,
        captchaErrorModalVisible: action.payload.visible
      };
    case actionTypes.MODAL.SET_CAPTCHA_SEND_MODAL_VISIBLE:
      return {
        ...state,
        captchaSendModalVisible: action.payload.visible
      };
    case actionTypes.MODAL.SET_CAPTCHA_RETURN_MODAL_VISIBLE:
      return {
        ...state,
        captchaReturnModalVisible: action.payload.visible
      };
    case actionTypes.MODAL.SET_INFO_MODAL_VISIBLE:
      return {
        ...state,
        infoModalState: {
          visible: action.payload.visible,
          title: action.payload.title,
          content: action.payload.content
        }
      };
    case actionTypes.MODAL.SET_GUARDIANSHIP_STATEMENT_MODAL_VISIBLE:
      return {
        ...state,
        guardianshipStatementModalVisible: action.payload.visible
      };
    case actionTypes.MODAL.SET_FILL_PASSPORT_MODAL_VISIBLE:
      return {
        ...state,
        fillPassportModalState: {
          visible: action.payload.visible,
          insureds: action.payload.insureds,
          serialNo: action.payload.serialNo,
          setAddEnListReq: action.payload.setAddEnListReq
        }
      };
    case actionTypes.LOADING.SET_LOADING_VISIBLE:
      return {
        ...state,
        loadingModalState: {
          visible: action.payload.visible,
          dealing: action.payload.dealing,
          policyperiod: action.payload.policyperiod,
          petLoading: action.payload.petLoading
        }
      };
    case actionTypes.MODAL.SET_RULE_VALID_ERROR_MODAL_VISIBLE:
      return {
        ...state,
        ruleValidErrorModalState: {
          visible: action.payload.visible,
          errorMsgs: [...action.payload.errorMsgs]
        }
      };
    case actionTypes.MODAL.SET_FILL_EXAMPLE_MODAL_VISIBLE:
      return {
        ...state,
        fillExampleModalVisible: action.payload.visible
      };
    case actionTypes.MODAL.SET_SELECT_VEHICLE_BRANDS_MODAL_VISIBLE:
      return {
        ...state,
        selectVehicleBrandsModalState: {
          visible: action.payload.visible,
          vehicleBrands: action.payload.vehicleBrands,
          selectItem: action.payload.selectItem
        }
      };
    case actionTypes.MODAL.SET_SELECT_VEHICLE_MODELS_MODAL_VISIBLE:
      return {
        ...state,
        selectVehicleModelsModalState: {
          ...state.selectVehicleModelsModalState,
          visible: action.payload.visible
        }
      };
    case actionTypes.MODAL.SET_SELECT_INSURANCE_TYPE_MODAL_VISIBLE:
      return {
        ...state,
        selectInsuranceTypeModalState: {
          visible: action.payload.visible,
          memberId: action.payload.memberId,
          nationalityType: action.payload.nationalityType
        }
      };
    case actionTypes.MODAL.SET_MEMBER_INFO_ERROR_MODAL_VISIBLE:
      return {
        ...state,
        memberInfoErrorModalState: {
          visible: action.payload.visible,
          title: action.payload.title,
          content: action.payload.content,
          fieldNames: action.payload.fieldNames
        }
      };
    case actionTypes.MODAL.SET_LOGIN_MODAL_VISIBLE:
      return {
        ...state,
        loginModalState: {
          visible: action.payload.visible
        }
      };
    case actionTypes.MODAL.SET_VET_HOSPITAL_MODAL_VISIBLE:
      return {
        ...state,
        vetHospitalModalVisible: action.payload.visible
      };
    case actionTypes.MODAL.SET_INSURE_HELPER_MODAL_VISIBLE:
      return {
        ...state,
        insureHelperModalVisible: action.payload.visible
      };
    case actionTypes.MODAL.SET_ABROAD_MODAL_VISIBLE:
      return {
        ...state,
        abroadModalVisible: action.payload.visible
      };
    case actionTypes.MODAL.SET_EXPLAIN_MODAL_VISIBLE:
      return {
        ...state,
        explainModalVisible: action.payload.visible
      };
    case actionTypes.MODAL.SET_PRODUCT_EXPLAIN_MODAL_VISIBLE:
      return {
        ...state,
        productExplainModalVisible: action.payload.visible
      };
    case actionTypes.MODAL.SET_CONFIRM_MODAL_VISIBLE:
      return {
        ...state,
        confirmModalVisible: action.payload.visible
      };
  }
  return state;
};
